import { settingsRoutes } from 'modules/settings/routes';
import {
    CommonSettingsSideMenu,
} from 'modules/settings/submodules/components/CommonSettingsSideMenu/CommonSettingsSideMenu';
import {
    ClientRolesAndPermissionsPage,
} from 'modules/settings/submodules/platformUsers/components/ClientRolesAndPermissions/ClientRolesAndPermissionsPage';
import { UserListPage } from 'modules/settings/submodules/platformUsers/components/UserListPage/UserListPage';
import { UserRolesPage } from 'modules/settings/submodules/platformUsers/components/UserRolesPage/UserRolesPage';
import React from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from 'shared/components/auth/PrivateRoute';

export const PlatformUsersRoutes = () => {
    return (
        <>
            <CommonSettingsSideMenu />
            <Switch>
                <PrivateRoute
                    path={settingsRoutes.PLATFORM_USERS.USER_ROLES}
                    component={UserRolesPage}
                />
                <PrivateRoute
                    path={settingsRoutes.PLATFORM_USERS.CLIENT_ROLES}
                    component={ClientRolesAndPermissionsPage}
                />
                <PrivateRoute
                    path={settingsRoutes.PLATFORM_USERS.ROOT}
                    component={UserListPage}
                />
            </Switch>
        </>
    );
};
